import React, { useState, Fragment, useEffect, useRef } from 'react'
import styled, { useTheme } from 'styled-components'
import { ReactEditor, useReadOnly, useFocused, useSelected, useSlate } from 'vendor/slate-react'
import { Transforms } from 'vendor/slate'
import { Button, FormControl, FormGroup } from 'react-bootstrap'
import 'katex/dist/katex.min.css'
import TeX from '@matejmazur/react-katex'
import { getTheme } from 'Shared/theme'

const MathWrapper = ({ attributes, children, element, editor }) => {
  const { formula } = element
  const readOnly = useReadOnly()
  const [formulaInputOpen, setFormulaInputOpen] = useState(false)
  const [formulaValue, setFormulaValue] = useState(formula)
  const path = ReactEditor.findPath(editor, element)
  const theme = useTheme()

  return (
    <Wrapper>
      <MathFormulaDisplay contentEditable={false}>
        <TeX math={formula !== formulaValue ? formulaValue : formula} block errorColor={getTheme(theme.id).bsRedColor} />
      </MathFormulaDisplay>
      {!readOnly && (
        <MathControlsAndFormulaWrapper contentEditable={false}>
          <MathControls>
            <MathControlButton
              variant="secondary"
              size="md"
              active={formulaInputOpen}
              onClick={() => {
                setFormulaInputOpen(!formulaInputOpen)
              }}
            >
              <i className="fad fa-function" />
            </MathControlButton>
          </MathControls>
          <MathControlsWrapper>
            {formulaInputOpen && (
              <MathFormula>
                <FormGroup className="mb-3">
                  <FormControl
                    size="md"
                    style={{ height: '70px' }}
                    as="textarea"
                    placeholder="Enter a math formula"
                    value={formulaValue || ''}
                    onChange={e => {
                      const { value } = e.target
                      if (value.includes('application/x-slate-clipboard:')) {
                        return
                      }
                      setFormulaValue(value)
                    }}
                  />
                </FormGroup>
                <Button
                  size="md"
                  variant={formula !== formulaValue && formulaValue && formulaValue.length > 0 ? 'primary' : 'secondary'}
                  disabled={formula === formulaValue || !formulaValue}
                  onClick={() => {
                    Transforms.setNodes(editor, { formula: formulaValue }, { at: path })
                  }}
                >
                  Save
                </Button>
              </MathFormula>
            )}
          </MathControlsWrapper>
        </MathControlsAndFormulaWrapper>
      )}
    </Wrapper>
  )
}
export default MathWrapper

const Wrapper = styled.div`
  margin: 15px 0px;
`
const MathFormulaDisplay = styled.div`
  border-radius: 3px;
  background: ${props => props.theme.bgLightestInverse};
  padding: 15px 10px;
  text-align: center;
  border-left: 3px solid ${props => props.theme.borderColor};
`
const MathControlsWrapper = styled.div``

const MathControlsAndFormulaWrapper = styled.div`
  margin: 15px 0px 15px 0px;
  width: 100%;
`

const MathControls = styled.div`
  justify-content: space-between;
  width: 100%;
  display: flex;
`

const MathControlButton = styled(Button)`
  color: ${props => props.theme.textGreyTinted}; !important;
  font-size: 11px;
  font-weight: bold;
`

const MathFormula = styled.div`
  font-size: 16px;
  color: ${props => props.theme.textGreyTintedLighter};
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
  text-align: right;
  input::placeholder {
    color: ${props => props.theme.textGreyTintedLighter};
  }
`
